<template>
  <main id="app" class="app-root">
    <Navbar class="Navbar" />

    <router-view />

    <div class="copyright-wrapper">
      <p class="copyright ff-en-1 fz-13 fz-mbl-12 c-100">
        Copyright © 2006-{{ currentYear }} GUGOBET. All rights reserved.
      </p>

      <BtnGoBottom />
    </div>
  </main>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import BtnGoBottom from '@/components/BtnGoBottom.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: { Navbar, BtnGoBottom },

  computed: {
    ...mapGetters(['currentYear']),
  },

  methods: {},
};
</script>

<style lang="scss">
.app-root {
  background-color: #040c1a;
}

.Navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.copyright-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: vw-dsk(20) vw-dsk($page-margin-x);
  color: #fff;

  @include mq(mbl) {
    padding: vw-mbl(8) vw-mbl($page-margin-x-mbl);
  }
  @include mq(mx-500) {
    padding: vw-mbl(15) vw-mbl($page-margin-x-mbl);
  }

  .copyright {
    @include mq(max-500) {
      padding-right: 20px;
    }
  }
}
</style>
